<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="/">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>案列管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 搜索 -->
    <div class="content">
      <el-form inline :model="query" label-position="right" label-width="60px" size="small" class="query-form"
        @submit.native.prevent="getList()">
        <el-form-item label="搜索">
          <el-input v-model="query.key" placeholder="请输入关键词"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="selClick();">查询</el-button>
          <el-button type="success"
            @click="dialogVisible=true;form={isEnable:true};selectedOptions=[];selectedArea=[];simglist=[]">新增</el-button>
        </el-form-item>
      </el-form>

      <!-- 主体 -->
      <el-card class="box-card table">
        <div class="clearfix" slot="header">
          <span>案例列表</span>
        </div>

        <!-- 列表 -->
        <el-table v-loading="loading" :data="tableData" ref="tableData" border stripe style="width:100%"
          @sort-change="sortChange" @filter-change="filterTag">
          <el-table-column label="标题">
            <template slot-scope="scope">
              <a :href="scope.row.url" target="_blank">{{scope.row.title}}</a>
            </template>
          </el-table-column>
          <el-table-column prop="realName" label="学生姓名"></el-table-column>
          <el-table-column label="籍贯">
            <template slot-scope="scope">{{scope.row.provinceName}} {{scope.row.cityName}}</template>
          </el-table-column>
          <el-table-column prop="eduBack" label="学历"></el-table-column>
          <el-table-column prop="schName" label="录取学校"></el-table-column>
          <el-table-column prop="abroadTime" label="留学时间"></el-table-column>
          <el-table-column prop="viewCount" label="浏览次数"></el-table-column>
          <el-table-column prop="createTime" label="添加时间"></el-table-column>

          <!-- 操作 -->
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button-group>
                <el-tooltip content="编辑" placement="top">
                  <el-button type="primary" size="small" icon="el-icon-edit" @click="editClick(scope.row)"></el-button>
                </el-tooltip>
                <el-tooltip content="删除" placement="top">
                  <el-button type="warning" size="small" icon="el-icon-delete" @click="delClick(scope.row)"></el-button>
                </el-tooltip>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="block" style="margin-top:20px;">
          <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage4" :page-size="pageSize" :page-sizes="[10,20,30,50,100]"
            layout="total,sizes,prev,pager,next,jumper" :total="total"></el-pagination>
        </div>
      </el-card>
    </div>

    <!-- 弹框 -->
    <el-dialog :title="form.id>0?'编辑案例':'添加案例'" :visible.sync="dialogVisible" @opened="dialogOpened()">
      <el-form :model="form" ref="form" label-width="100px" :status-icon="true"
        @submit.native.prevent="submitForm(form)">
        <el-tabs>
          <el-tab-pane label="基本信息">

            <el-form-item label="案例标题">
              <el-input v-model="form.title" placeholder="请输入案例标题"></el-input>
            </el-form-item>

            <el-form-item prop="realName" label="学生姓名" :rules="[{required:true,message:'不能为空'}]">
              <el-input v-model="form.realName" placeholder="请输入姓名"></el-input>
            </el-form-item>

            <el-form-item label="学生头像" :rules="[{required:true,message:'不能为空'}]">
              <div id="uploadBtn14" class="uploader uploader-warning" style="position:absolute;top:5px;"></div>
              <img id="relativeName" :src="domain+form.imgUrl" alt
                style="width:50px;position:relative;left:100px;top:5px;" v-if="form.imgUrl" />
              <span class="uploadslot">*图片尺寸：200*200</span>
            </el-form-item>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="学生籍贯" :rules="[{required:true,message:'不能为空'}]">
                  <el-cascader :options="arealist" v-model="selectedArea" clearable
                    :props="{value:'areaID',label:'areaName'}"></el-cascader>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item prop="relationType" label="关联类型" :rules="[{required:true,message:'不能为空'}]">
                  <el-select v-model="form.relationType" clearable placeholder="请选择类型">
                    <el-option v-for="item in reltypelist" :label="item.name" :key="item.id"
                      :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="schID" label="录取学校" :rules="[{required:true,message:'不能为空'}]"
                  v-if="form.relationType==1">
                  <el-select v-model="form.schID" filterable clearable remote placeholder="请选择学校">
                    <el-option v-for="item in schlist" :label="item.name" :key="item.id" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="collegeID" label="录取学校" :rules="[{required:true,message:'不能为空'}]" v-else>
                  <el-select v-model="form.collegeID" filterable clearable remote placeholder="请选择学校">
                    <el-option v-for="item in collegelist" :label="item.name" :key="item.id"
                      :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item prop="abroadYear" label="留学时间" :rules="[{required:true,message:'不能为空'}]">
                  <el-cascader :options="timeList" v-model="selectedOptions" @change="abroadTimeChange" clearable
                    :props="{value:'id',label:'value'}"></el-cascader>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="eduBack" label="学生学历" :rules="[{required:true,message:'不能为空'}]">
                  <el-input v-model="form.eduBack" placeholder="请输入学历"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-tab-pane>

          <el-tab-pane label="内容">
            <el-form-item label="学校简介">
              <div style="position:relative;">
                <vue-ueditor-wrap v-model="form.content" :config="editorConfig"></vue-ueditor-wrap>
              </div>
            </el-form-item>
          </el-tab-pane>

          <el-tab-pane label="图片">
            <div class="uploader uploader-warning" id="uploadBtn2">
            </div>
            <el-row>
              <el-col :span="6" v-for="(item, index) in simglist" :key="index" style="padding: 5px">
                <el-card :body-style="{ padding: '0px' }">
                  <el-image :src="domain + item.imgSmall" class="image" style="width: 100%; height: 180px"
                    :preview-src-list="[domain + item.imgBig]"></el-image>

                  <div style="padding: 5px 14px 10px 14px">
                    <div class="bottom clearfix">
                      <el-button-group>
                        <el-tooltip content="前移" placement="top">
                          <el-button type="primary" size="small" @click="imgMove(index)" v-if="index != 0">前移</el-button>
                        </el-tooltip>
                        <el-tooltip content="删除" placement="top">
                          <el-button type="danger" size="small" @click="imgRemove(index)">
                            删除</el-button>
                        </el-tooltip>
                      </el-button-group>
                    </div>
                  </div>
                </el-card>
              </el-col>
            </el-row>
            <div style="height: 10px"></div>
            <el-alert style="margin-bottom: 10px">
              <p>说明：上传图片数量不超过2张</p>

            </el-alert>
          </el-tab-pane>
        </el-tabs>


        <el-form-item>
          <el-button type="primary" :loading="submiting" native-type="submit">提交</el-button>
          <el-button @click="dialogVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import VueUeditorWrap from "vue-ueditor-wrap";
import url from "@/plugins/urlHelper.js";
import json from "@/plugins/jsonHelper.js";
export default {
  data() {
    return {
      domain: url.getDomain(),
      query: {},
      form: {},
      dialogVisible: false,
      loading: false,
      submiting: false,
      tableData: [],
      total: 0,
      pageSize: 10,
      currentPage4: 1,
      content: "",
      editorConfig: {
        zIndex: 3000, //配置控件组件弹出层
        initialFrameHeight: 300, //设置高度
        initialFrameWidth: "99%", //设置宽度
        UEDITOR_HOME_URL: url.getUEConfig(),
        serverUrl: url.getUE()
      },
      selectedOptions: [],
      timeList: [],
      selectedArea: [],
      arealist: [],
      schlist: [],
      reltypelist: [{ id: 1, name: "语言大学" }, { id: 2, name: "大学" }],
      collegelist: [],
      simglist:[]
    };
  },
  methods: {
    handleSizeChange: function(val) {
      this.pageSize = val;
      this.currentPage4 = 1;
      this.getList();
    },
    handleCurrentChange: function(val) {
      this.currentPage4 = val;
      this.getList();
    },
    // 排序
    sortChange: function(sortColumn) {
      this.query.sort = sortColumn.sort;
      this.query.order = sortColumn.order;
      this.getList();
    },
    // 筛选
    filterTag: function(filter) {
      var val = filter["isEnable"][0];
      this.form.isEnable = val;
      this.getList();
    },
    // 地区
    getAreaList: function() {
      var _this = this;
      var link = url.getCommon("getarea_China");
      $.get(link, {}, data => {
        _this.arealist = data;
      });
    },
    // 语言学校
    getSchList: function() {
      var _this = this;
      var link = url.getCommon("getschollall");
      $.get(link, {}, data => {
        _this.schlist = data;
      });
    },
    // 大学
    getCollegeList: function() {
      var _this = this;
      var link = url.getCommon("getcollegeall");
      $.get(link, {}, data => {
        _this.collegelist = data;
      });
    },
    //留学时间
    getTimeList() {
      var yearList = [];
      var year = new Date().getFullYear();
      var monthList = json.getMonth();
      for (var i = year; i > year - 15; i--) {
        yearList.push({
          id: i,
          value: i,
          children: monthList
        });
      }
      this.timeList = yearList;
    },
    //选择留学时间
    abroadTimeChange() {
      this.form.abroadYear = this.selectedOptions[0];
      this.form.abroadMonth = this.selectedOptions[1];
    },
    // 切换
    tabClick: function() {
      (this.tableData = []), this.getList();
    },
    // 列表
    getList: function() {
      var _this = this;
      _this.loading = true;
      var params = _this.query;
      params.pageSize = _this.pageSize;
      params.pageIndex = _this.currentPage4;
      var link = url.getVideo("getlist_case");
      $.get(link, params, data => {
        _this.loading = false;
        _this.tableData = data.list;
        _this.total = data.total;
      });
    },
    // 查询
    selClick: function() {
      this.currentPage4 = 1;
      this.getList();
    },
    // 编辑
    editClick: function(row) {
      var _this = this;
      _this.dialogVisible = true;
      var id = row.id;
      var link = url.getVideo("getmodel_case");
      $.get(link, { id: id }, data => {
        _this.form = data;
        _this.selectedOptions = [data.abroadYear, data.abroadMonth];
        _this.selectedArea = [data.provinceID, data.cityID];
        _this.simglist = data.imgList?JSON.parse(data.imgList):[]
      });
    },
    // 删除
    delClick: function(row) {
      var _this = this;
      var id = row.id;
      var link = url.getVideo("delete_case");

      this.$confirm("确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          $.post(link, { id: id }, res => {
            if (res.status) {
              _this.dialogVisible = false;
              _this.getList();
              _this.$message({
                type: "success",
                message: res.msg
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 上传
    dialogOpened: function() {
      var _this = this;
      if ($("#uploadBtn14 input").length == 0) {
        $("#uploadBtn14").uploader({
          url: url.getUpload(),
          text: "上传图片",
          fileExts: "jpg;png",
          type: "dialog",
          maxSize: 1024 * 1024 * 1,
          subfolder: "content",
          more: false,
          auto: true,
          coverParams: {
            title: "上传图片",
            targetWidth: 200,
            targetHeight: 200
          },
          onSuccess: function(data) {
            var src = url.getDomain + data.relativeName;
            _this.$set(_this.form, "imgUrl", data.relativeName);
          }
        });
      }
      // 大小图
      if ($("#uploadBtn2 input").length == 0) {
        $("#uploadBtn2").uploader({
          url: url.getUpload(),
          text: "上传图片",
          fileExts: "jpg;png",
          more: true, //是否可以上传多个
          auto: true, //是否自动上传simglist
          type: "imgdouble",
          minWidth: 500,
          minHeight: 500,
          maxWidth: 2000,
          maxHeight: 2000,
          handleType: "0", //对于大小图模式最好不要自动处理
          maxSize: 1024 * 1024 * 1,
          onSuccess: function (data) {
            var small = data.small;
            var big = data.big;
            //增加上传处理后台处理
            var imgData = {
              imgSmall: small.relativeName,
              imgBig: big.relativeName,
            };
             _this.simglist.push(imgData);
          },
        });
      }
    },
     //移动
     imgMove(index) {
            var slist = Object.assign([], this.simglist);
            // var blist = Object.assign([], this.bimglist);
            var sabove = index - 1;
            if (sabove == -1) {
                sabove = slist.length - 1;
            }
            var stemp = slist[index];
            slist[index] = slist[sabove];
            slist[sabove] = stemp;
            this.simglist = slist;

            var babove = index - 1;
            if (babove == -1) {
                sabove = slist.length - 1;
            }
            var btemp = blist[index];
            blist[index] = blist[babove];
            blist[babove] = btemp;
            this.bimglist = blist;
        },
        //删除
        imgRemove(index) {
            var _this = this;
            _this.simglist.splice(index, 1);
            _this.bimglist.splice(index, 1);
        },
    // 提交
    submitForm: function(formName) {
      var _this = this;
      var link = url.getVideo("save_case");
      var info = this.form;

      if (_this.form.imgUrl == undefined) {
        _this.$message({
          type: "error",
          message: "请上传图片"
        });
        return;
      }

      if (this.selectedArea.length <= 0) {
        _this.$message({
          type: "error",
          message: "请选择学校地区"
        });
        return;
      }
      if (_this.simglist.length > 0) {
        info.imgList = JSON.stringify(this.simglist);
      }
      info.provinceID = this.selectedArea[0];
      info.cityID = this.selectedArea[1];

      this.$refs.form.validate(valid => {
        if (valid) {
          _this.submiting = true;

          // 提交后台  添加或修改
          $.post(link, info, res => {
            _this.submiting = false;
            if (res.status) {
              _this.dialogVisible = false;
              _this.getList();
              _this.$message({
                type: "success",
                message: res.msg
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg
              });
            }
          });
        } else {
          return;
        }
      });
    }
  },
  components: {
    VueUeditorWrap
  },
  mounted() {
    // 地区
    this.getAreaList();
    // 语言学校
    this.getSchList();
    // 学校
    this.getCollegeList();
    // 学校时间
    this.getTimeList();
    // 列表
    this.getList();
  }
};
</script>